module.exports = __webpack_public_path__ + "img/middleBg.ac579b53.jpg";